import { useCommonActionFromDALV2 } from '@shares/actionFormDALV2';
// import { CommonNotificationSaveError } from '@shares/CommonNotification';
// import { get } from 'lodash';
import { useAsyncRetry } from 'react-use';
import GetTermPangoConfig from './api';
import { TResponseGetTermPangoConfig } from './type';

export type TUseGetTermPangoConfig = {
  isLoading?: boolean;
  response?: TResponseGetTermPangoConfig;
  onRetry: () => void;
};

const useGetTermPangoConfig = (): TUseGetTermPangoConfig => {
  const commonActionFromDALV2 = useCommonActionFromDALV2();

  const stateAsyncRetry = useAsyncRetry(async () => {
    const response: Promise<any> = await commonActionFromDALV2(GetTermPangoConfig);
    const result = await response;
    // if (!result?.success) CommonNotificationSaveError(get(result, 'message', 'Something went wrong!'));
    return result;
  }, []);

  return {
    response: stateAsyncRetry?.value,
    isLoading: stateAsyncRetry?.loading,
    onRetry: stateAsyncRetry?.retry,
  };
};

export default useGetTermPangoConfig;
